
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Success extends Component {

    constructor(props) {
        super(props)
        const { successMsg } = props
        this.state = {
            successMsg: successMsg
        }
        this.removeSuccess = this.removeSuccess.bind(this)
        this.findMsgWithIndex = this.findMsgWithIndex.bind(this)
    }
    removeSuccess(index) {
        this.setState({ indexRMV: index })
        var successMsg = this.state.successMsg;
        const indexRMV = successMsg.find(this.findMsgWithIndex)
        successMsg.splice(indexRMV, 1)
        this.setState({ successMsg: successMsg });
    }

    findMsgWithIndex(element) {
        if (element.index === this.state.indexRMV) {
            return element.index;
        } else {
            return -1
        }
    }

    render() {
        return (
            <div className="success-msgs-list">
                <div className="success-msg">
                    {this.state.successMsg.map((item, index) => (
                        (() => (setTimeout(() => (
                            this.removeSuccess(item.index)
                        )
                            , 9000)
                        ))() &&
                        <p className='notif success' onClick={() => { this.removeSuccess(item.index) }} key={index}>
                            <span>SUCCESS: </span>{item.message
                            }</p>
                    ))
                    }
                </div>
            </div>
        )
    }
}
Success.propTypes = {
    successMsg: PropTypes.array
};
export default Success;


// WEBPACK FOOTER //
// ./src/components/success.js